// extracted by mini-css-extract-plugin
export default {"spin":"MaintenancePage_spin__iLPXw"};